import { deviceSystemAgeOptions } from "constants/DeviceSystemAgeOptions"
import {
  contractorDevicePhysicalStatusOptions,
  deviceAccessoriesOptions,
  devicesAlertsOptions,
  devicesMembershipOptions,
  deviceSystemTypeOptions,
  hvacOptions,
} from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { CustomerAddress } from "components/table/columnComponents/CustomerAddress"
import { CustomerEmail } from "components/table/columnComponents/CustomerEmail"
import { CustomerMembershipType } from "components/table/columnComponents/CustomerMembershipType"
import { CustomerName } from "components/table/columnComponents/CustomerName"
import { StatusOfPhysical } from "components/table/columnComponents/StatusOfPhysical"

const contractorDevicesDefaultTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "",
    type: "checkbox",
    name: "checkbox",
    cellComponent: "checkbox",
    size: "mini",
  },
  {
    title: "S/N",
    type: "sort-search",
    name: "sn",
    size: "small",
  },
  {
    title: "Status",
    type: "select",
    name: "phisical_status",
    size: "small",
    options: contractorDevicePhysicalStatusOptions,
    cellComponent: StatusOfPhysical,
  },
  {
    title: "Customer Email",
    type: "sort-search",
    name: "email",
    size: "large",
    cellComponent: CustomerEmail,
  },
  {
    title: "Customer",
    type: "sort-search",
    name: "homeowner_name",
    size: "middle",
    cellComponent: CustomerName,
  },
  {
    title: "City",
    type: "sort-search",
    size: "middle",
    name: "city",
  },
  {
    title: "State",
    type: "sort-search",
    size: "middle",
    name: "state",
  },
  {
    title: "Country",
    type: "sort-search",
    name: "country",
  },
  {
    title: "ZIP Code",
    type: "sort-search",
    name: "zip_code",
    size: "small",
  },
  {
    title: "Activation date",
    type: "sort-date-range",
    name: "activation_date",
    size: "middle",
  },
  {
    title: "Address",
    type: "sort-search",
    name: "address",
    cellComponent: CustomerAddress,
  },
  {
    title: "Installation type",
    type: "select",
    size: "small",
    name: "installation_type",
    options: hvacOptions,
  },
  {
    title: "Alerts",
    type: "select",
    size: "small",
    name: "alerts",
    options: devicesAlertsOptions,
  },
  {
    title: "Membership",
    type: "select",
    size: "small",
    name: "membership",
    options: devicesMembershipOptions,
  },
  {
    title: "Membership type",
    type: "search",
    name: "membership_name",
    size: "middle",
    cellComponent: CustomerMembershipType,
  },
  {
    title: "System type",
    type: "select",
    size: "small",
    name: "system_type",
    options: deviceSystemTypeOptions,
  },
  {
    title: "System age",
    type: "select",
    size: "middle",
    name: "system_age",
    options: deviceSystemAgeOptions,
  },
  {
    title: "Accessories",
    type: "select",
    size: "small",
    name: "accessories",
    options: deviceAccessoriesOptions,
  },
  {
    title: "Notes",
    type: "search",
    name: "notes",
    size: "middle",
  },
]

export default contractorDevicesDefaultTableHeaderCells
